import CatchStoryPostLink from "components/boards/post/catchstory/CatchStoryPostLink";
import CatchImage from "components/boards/post/catch/CatchImage";
import React, { Fragment } from "react";
import CatchStoryInfo from "components/boards/post/catchstory/CatchStoryInfo";
const CatchStoryThumb = ({ vod, inflowPath, storyOrderInTotal, total, compareBroadDate, location }) => {
    // vod 정보 조회
    const { ucc = {} } = vod;

    return (
        <Fragment>
            <CatchStoryPostLink vod={vod} inflowPaths={inflowPath} storyOrderInTotal={storyOrderInTotal} total={total}>
                {/* 캐치 세로형 썸네일 노출 */}
                <CatchImage vod={ucc}/>
                {/* 캐치 정보 노출 */}
                <CatchStoryInfo inflowPath={inflowPath} vod={vod} compareBroadDate={compareBroadDate} location={location}/>
            </CatchStoryPostLink>
        </Fragment>
    );
};

export default CatchStoryThumb;
